<template>
  <v-container id="citygroup-edit" fluid tag="section">
    <v-card>
      <v-form id="form" class="px-5 pt-5">
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              v-model="fundAc.accountKind"
              label="Account Kind"
              :items="['BANK', 'WALLET', 'CREDIT_CARD']"
            ></v-select>
          </v-col>
          <v-col>
            <z-date-picker
              :label="$i18n.t('Account Opening Date')"
              v-model="fundAc.openingDate"
            />
          </v-col>
          <v-col v-if="!id" cols="12" md="3">
            <v-text-field
              v-model="fundAc.openingBalance"
              type="number"
              :label="$i18n.t('Opening Balance')"
          /></v-col>
          <v-col v-else>
            <div class="custom-justify-content-center">
              <h3>{{ "Account Balance : " + fundAc.balance }}</h3>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="fundAc.details.accountName"
              placeholder="Ex. Saving Account"
              :label="$i18n.t('Account Name')"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="fundAc.details.bankName"
              :label="$i18n.t('Bank Name')"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="fundAc.details.identificationNumber"
              :label="$i18n.t('Identification Number')"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="fundAc.details.bankIFSCCode"
              :label="$i18n.t('IFSC Code')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-right mb-5">
            <v-btn
              color="success"
              class="mr-0"
              @click="save()"
              :loading="loading"
            >
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class FundAccountEdit extends Vue {
  fundAc = { details: {}, openingBalance: 0.0 };
  @Watch("fundAc")
  co() {
    console.log(this.fundAc);
  }
  id = null;

  get loading() {
    return common.loading;
  }

  validateSave() {
    if (!this.fundAc.accountKind) {
      common.setError("Please Enter Account Kind");
      return false;
    }
    if (
      !Object.keys(this.fundAc.details) ||
      Object.keys(this.fundAc.details).length == 0
    ) {
      common.setError("Please Enter Account Details");
      return false;
    }
    return true;
  }

  async save() {
    try {
      if (!this.validateSave()) return;
      common.setLoading(true);
      const response = await doPost("/api/fund/account/save", this.fundAc);
      if (!this.id) this.$router.push("/settings/fundaccounts/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/fund/account/" + id + "/detail");
      if (!response.cities) response.cities = [];
      this.fundAc = response;
      this.id = this.fundAc._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}

.custom-justify-content-center {
  display: flex;
  justify-content: center;
}
</style>
